import type { IconComponent } from '@components/icons/types'

interface ExternalLinkProps {
    /** Size of the icon (applies to both width and height) */
    size?: number
}

/** External link icon (box with arrow) */
export const ExternalLink: IconComponent<ExternalLinkProps> = ({
    width,
    height,
    size = 24,
    ...restOfProps
}) => (
    <svg
        fill='none'
        height={height ?? size}
        width={width ?? size}
        viewBox='0 0 21 21'
        xmlns='http://www.w3.org/2000/svg'
        {...restOfProps}
    >
        <clipPath id='external-link-a'>
            <path d='m0 0h21v21h-21z' />
        </clipPath>
        <clipPath id='external-link-b'>
            <path d='m.5.5h20v20h-20z' />
        </clipPath>
        <mask
            id='external-link-c'
            height='21'
            maskUnits='userSpaceOnUse'
            width='21'
            x='0'
            y='0'
        >
            <path d='m20.5.5h-20v20h20z' fill='#d9d9d9' />
        </mask>
        <g clipPath='url(#external-link-a)'>
            <g clipPath='url(#external-link-b)'>
                <g mask='url(#external-link-c)'>
                    <path
                        d='m12.5 3.5h-5c-1.88562 0-2.82843 0-3.41421.58579-.58579.58578-.58579 1.52859-.58579 3.41421v6c0 1.8856 0 2.8284.58579 3.4142.58578.5858 1.52859.5858 3.41421.5858h6c1.8856 0 2.8284 0 3.4142-.5858s.5858-1.5286.5858-3.4142v-5.07692'
                        stroke='#fff'
                        strokeLinecap='round'
                        strokeWidth='1.5'
                    />
                    <path
                        d='m14.5 1.43234h4.214c.2762 0 .5.22386.5.5v4.21405'
                        stroke='#fff'
                        strokeLinecap='round'
                        strokeWidth='1.5'
                    />
                    <rect
                        fill='#fff'
                        height='10'
                        rx='.75'
                        transform='matrix(.70710678 .70710678 -.70710678 .70710678 6.33126 -12.420334)'
                        width='1.5'
                        x='18.1583'
                        y='1.43234'
                    />
                </g>
            </g>
        </g>
    </svg>
)
